import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.filter.js";
import cloneDeep from 'lodash/cloneDeep';
/**
 *
 * @param {Object} payload payload
 * @param {Object} payload.question menu insight question
 * @param {Object} payload.majorGroupsByFamilyGroup major groups organised by family
 * @param {Array} payload.products products currently available
 *
 * @returns {Array} array of 'dishes' based on family group
 *
 */

function getFamilyGroupDishes(_ref) {
  var question = _ref.question,
      majorGroupsByFamilyGroup = _ref.majorGroupsByFamilyGroup,
      products = _ref.products;
  // find family ref for question
  var familyGroupRef = question.menuFamilyGroupRef;
  var majorGroups = cloneDeep(majorGroupsByFamilyGroup[familyGroupRef]); // loop through major groups and create a new top level 'dish' object for each major group

  var dishes = Array.isArray(majorGroups) ? majorGroups.map(function (mg) {
    var _products$familyGroup;

    // make only one subcategory for each major group
    // calculate category options by major group if available
    var selected = (products === null || products === void 0 ? void 0 : (_products$familyGroup = products[familyGroupRef]) === null || _products$familyGroup === void 0 ? void 0 : _products$familyGroup[mg.ref]) || [];
    var subcategoryOptions = getSubcategoryOptionsByMajorGroup(question, mg, selected, {
      ref: familyGroupRef
    });
    var categoryOptions = [{
      name: mg.name,
      options: subcategoryOptions,
      ref: mg.ref,
      subcategory: mg.name,
      isMisc: mg.isMisc
    }];
    var category = {
      category: mg.name,
      image: null,
      // This is for tiled MI questions only (currently not supported)
      name: mg.name,
      options: categoryOptions,
      ref: mg.ref,
      isMisc: mg.isMisc
    };
    return category;
  }) : [];
  return dishes;
}
/**
 *
 * @param {Object} question menu insight question
 * @param {Object} product product
 *
 * @returns {Array} array of subquestions for the subcategory
 *
 */


function getSubquestionsForSubcategory(question, product) {
  var subQuestions = [];
  var ratings = cloneDeep(question.ratings); // create subQuestion for each rating

  for (var i in ratings) {
    var rating = cloneDeep(ratings[i]);
    var reasonSections = cloneDeep(rating.reasonSections);

    for (var j in reasonSections) {
      var section = cloneDeep(reasonSections[j]);
      var sectionOptions = section.reasons.map(function (r) {
        return {
          id: r.id,
          label: r.text,
          val: r.id
        };
      });
      subQuestions.push({
        id: 'question' + question.id + 'product' + product.ref + 'rating' + i + 'reasonSection' + j,
        type: 'fib-select-option',
        showIf: section.showIf,
        required: false,
        // TODO - find out what sets this
        label: section.title,
        meta: {
          rating: rating,
          section: section
        },
        props: {
          center: true,
          multiple: true,
          options: sectionOptions
        }
      });
    }
  } // add comments box if applicable


  subQuestions.push({
    id: 'question' + question.id + 'product' + product.ref + 'comment',
    type: 'fib-comments',
    required: true,
    // TODO : find out if this needs setting and how to check if it is
    label: '',
    props: {
      rows: 6
    }
  });
  return subQuestions;
}
/**
 *
 * @param {Object} question menu insight question
 * @param {Object} mg major group
 * @param {Array} products array of available products
 *
 * @returns {Array} array of subcategory options for the major group
 *
 */


function getSubcategoryOptionsByMajorGroup(question, mg, products) {
  var fg = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  // TODO: this is slow and inefficient - need to refactor to store products by major group where possible
  var filtered = cloneDeep(products).filter(function (p) {
    return p.majorGroupRef === mg.ref || p.majorGroupRef === null && mg.isMisc && fg.ref === p.familyGroupRef;
  }); // the second check allows misc types to match

  return filtered.map(function (f) {
    var option = {
      id: f.ref,
      ref: f.ref,
      title: f.name
    }; // if follow up questions turned on, add subQuestions

    if (question.followUpQuestion) {
      option.subQuestions = getSubquestionsForSubcategory(question, f);
    }

    return option;
  });
}

export default getFamilyGroupDishes;